/* eslint-disable */
import React, { useEffect } from "react";

//** import components */
import Header from "components/Common/Header/Header";

import ApiDocsListBody from "components/ApiDocsComponents/ApiDocsListBody/ApiDocsListBody";

const Dashboard = () => {
  //assign browser title is dashboard
  useEffect(() => {
    document.title = "API Documentation";
  }, []);

  return (
    <main id="app">
      <Header moduleName="api-docs" />

      <ApiDocsListBody />

    </main>
  );
};

export default Dashboard;
